import React, { useState, useEffect } from 'react';
import { Button, ButtonToolbar, Row, Card, CardBody } from 'reactstrap';
// import { Field, reduxForm } from 'redux-form';
import { Link, NavLink, useHistory } from 'react-router-dom';
import { Formik, Field, Form, FieldArray } from 'formik';
import FormikMaterialTextField from './FormikMaterialTextField';
import { useSelector, useDispatch } from 'react-redux';
import ReferenceDataSelect from '../../components/ReferenceDataSelect';
import FinancialYearSelect from './financialYearSelect';
import utils, { getUrlWithEncryptedQueryParams } from 'lib/utils';
import LogoLoader from 'common/LogoLoader';
import { actions as financeActions } from 'redux/finance';
import { COMPANY_AFFILIATE_ENUM } from 'constants/enums';
import * as handlers from '../handlers';
import Collapse from '../../components/Collapse';
import RupeeIcon from 'mdi-react/RupeeIcon';
import InstalledCapacity from './InstalledCapacity';
import UploadDocument from '../../UploadBusiness/components/UploadDocument';
import { actions as uploadActions } from 'redux/uploadDoc';
import { actions as companyActions } from 'redux/companies';
import useQuery from 'lib/hooks/useQuery';
import FormikMaterialTextFieldNumber from 'common/Form/FormikMaterialTextFieldNumber';

const getInitialValues = (details, company_id, company_affiliate_enum, companyData) => {
  let companyId = 0;
  let affiliateId = 0;
  if (company_affiliate_enum == COMPANY_AFFILIATE_ENUM.COMPANY) {
    companyId = company_id;
  } else {
    affiliateId = company_id;
  }
  let params = {
    company_id: _.get(details, 'company_id') || companyId,
    company_affiliate_id: _.get(details, 'company_affiliate_id') || affiliateId,
    person_id: _.get(details, 'person_id') || 0,
    year_of_incorporation: _.get(details, 'year_of_incorporation') || '',
    nature_of_business_enum: _.get(companyData, 'nature_of_business_enum') || 0,
    nature_of_businessenum_code: _.get(details, 'nature_of_businessenum_code') || '',
    industry_type_enum: _.get(details, 'industry_type_enum') || 0,
    industry_type_enum_code: _.get(details, 'industry_type_enum_code') || '',
    business_size_enum: _.get(details, 'business_size_enum') || 0,
    business_size_enum_code: _.get(details, 'business_size_enum_code') || '',
    financial_year: _.get(details, 'financial_year') || '',
    annual_turnover: _.get(details, 'annual_turnover') || '',
    people_employed_enum: _.get(details, 'people_employed_enum') || 0,
    // attachments: null,
    installedcapacity: null,

    company_affiliate_enum: company_affiliate_enum,
  };
  return params;
};

const FinanceForm = (props) => {
  const { back } = useQuery();
  const { entity_id, company_affiliate_enum, kyc_status_enum_code, display_member } = props;
  const id = props.id;
  const user = useSelector((state) => state.user);
  const type_of_individual_enum = _.get(user, 'profile.person.type_of_individual_enum') || false;
  const kycUser = useSelector((state) => state.kycUser);
  let userRole = _.get(user, 'profile.person.type_of_individual_enum') || 0;
  const [timestamp, setTimestamp] = useState(Date.now());

  let idCompare = parseInt(id);

  let isAdmin = false;
  if (idCompare !== window.user.userid) {
    isAdmin = true;
  }
  if (idCompare === window.user.userid) {
    isAdmin = false;
  }

  let kycStatusKey = false;

  const acl = utils.getACL(user);
  let prevLink = `/account/${id}/upload`;
  let nextLink = `/account/${id}/subscription`;
  if (isAdmin) {
    prevLink = `/account/${id}/upload?back=${back}`;
    nextLink = `/account/${id}/subscription?back=${back}`;
  }
  const upload = useSelector((state) => state.uploadDoc);

  const finance = useSelector((state) => state.finance);
  //busy flag
  const busy = _.get(finance, 'busy') || false;
  const ids = _.get(finance, 'ids') || [];
  const companyId = ids[0];
  let financeDetails = _.get(finance, `entities.${companyId}`) || {};

  //to render between company and its affiliates
  let entityIdFinance = _.get(financeDetails, 'company_id') || _.get(financeDetails, 'company_affiliate_id') || 0;
  if (entity_id !== entityIdFinance) {
    financeDetails = {};
  }

  const dispatch = useDispatch();
  const companies = useSelector((state) => state.companies);
  const companyDetailsId = _.get(user, 'profile.person.company_id') || 0;
  const companyData = _.get(companies, `entities[${companyDetailsId}]`) || {};
  const busyForCompanies = _.get(companies, 'busy') || false;

  useEffect(() => {
    if (entity_id !== undefined) {
      let companyId = 0;
      let affiliateId = 0;
      if (company_affiliate_enum == COMPANY_AFFILIATE_ENUM.COMPANY) {
        companyId = entity_id;
      } else {
        affiliateId = entity_id;
      }
      const params = {
        company_id: companyId,
        company_affiliate_id: affiliateId,
        person_id: 0,
      };
      dispatch(financeActions.fetchDetails(params));
    }
  }, [props.entity_id, timestamp]);

  useEffect(() => {
    let params = {
      entity_id: entity_id,
      company_affiliate_enum: company_affiliate_enum,
    };
    dispatch(uploadActions.fetchList(params));
  }, [entity_id]);

  const params = {
    person_id: parseInt(id),
  };

  useEffect(() => {
    if (companyId) {
      dispatch(companyActions.fetchList(params));
    }
  }, [companyId]);

  if (busy || busyForCompanies) {
    return (
      <div className="bfc-body bfc-form">
        <div className="panel__refresh">
          <LogoLoader />
        </div>
      </div>
    );
  }

  const handleCheck = async (values, formikBag) => {
    handlers.handleCreate(values, formikBag, setTimestamp, id);
  };

  //==============================================================================================

  let uploadedFileNameFront,
    uploadedFileNameBack,
    attachmentIdFront,
    attachmentIdBack,
    attachmentIdBusinessReg,
    attachmentIdCompany,
    attachmentIdPropreitor,
    attachmentIdNameForm12,
    attachmentIdNameForm80,
    attachmentIdAuthority,
    attachmentIdCancelledCheque,
    attachmentPathFront,
    attachmentPathBack,
    attachmentPathBusinessReg,
    attachmentPathCompany,
    attachmentPathPropreitor,
    attachmentPathNameForm12,
    attachmentPathNameForm80,
    attachmentPathAuthority,
    attachmentPathCancelledCheque,
    attachmentIdBalanceSheet,
    attachmentIdPLStatement,
    attachmentIdIncomeTaxReturnsLatest,
    attachmentIdIncomeTaxReturnsPreviousYear,
    attachmentPathBalanceSheet,
    attachmentPathPLStatement,
    attachmentPathIncomeTaxReturnsLatest,
    attachmentPathIncomeTaxReturnsPreviousYear,
    uploadedEntityTypeEnum,
    uploadedEntityTypeEnumCode,
    uploadedEntityTypeEnumToPass = 0,
    uploadedFileNameBusinessReg,
    uploadedFileNameForm80,
    uploadedFileNameCompany,
    uploadedFileNamePropreitor,
    uploadedFileNameForm12,
    uploadedFileNameAuthority,
    uploadedFileNameCancelledCrossedCheque,
    uploadFileNameBalanceSheet,
    uploadFileNamePLStatement,
    uploadFileNameIncomeTaxReturnsLatest,
    uploadFileNameIncomeTaxReturnsPreviousYear;

  for (let i = 0; i < upload.ids.length; i++) {
    let id = upload.ids[i];
    const uploadList = upload.entities[id] || [];
    const frontBackEnumValue = uploadList.front_back_enum;

    if (
      uploadList.entity_type_enum == 1 ||
      uploadList.entity_type_enum == 2 ||
      uploadList.entity_type_enum == 3 ||
      uploadList.entity_type_enum == 16 ||
      uploadList.entity_type_enum == 17 ||
      uploadList.entity_type_enum == 18
    ) {
      uploadedEntityTypeEnum = uploadList.entity_type_enum;
      uploadedEntityTypeEnumCode = uploadList.entity_type_enum_code;
    }
    if (
      uploadList.entity_type_enum == 1 ||
      uploadList.entity_type_enum == 2 ||
      uploadList.entity_type_enum == 3 ||
      uploadList.entity_type_enum == 16 ||
      uploadList.entity_type_enum == 17 ||
      uploadList.entity_type_enum == 18
    ) {
      frontBackEnumValue == 1
        ? (uploadedFileNameFront = uploadList.attachment_file_name)
        : (uploadedFileNameBack = uploadList.attachment_file_name);
    } else {
      if (uploadList.entity_type_enum == 6) {
        uploadedFileNameBusinessReg = uploadList.attachment_file_name;
      }
      if (uploadList.entity_type_enum == 7) {
        uploadedFileNameCompany = uploadList.attachment_file_name;
      }
      if (uploadList.entity_type_enum == 8) {
        uploadedFileNamePropreitor = uploadList.attachment_file_name;
      }
      if (uploadList.entity_type_enum == 9) {
        uploadedFileNameForm12 = uploadList.attachment_file_name;
      }
      if (uploadList.entity_type_enum == 10) {
        uploadedFileNameForm80 = uploadList.attachment_file_name;
      }
      if (uploadList.entity_type_enum == 11) {
        uploadedFileNameAuthority = uploadList.attachment_file_name;
      }
      if (uploadList.entity_type_enum == 15) {
        uploadedFileNameCancelledCrossedCheque = uploadList.attachment_file_name;
      }
      ////////////
      if (uploadList.entity_type_enum == 21) {
        uploadFileNameBalanceSheet = uploadList.attachment_file_name;
      }
      if (uploadList.entity_type_enum == 22) {
        uploadFileNamePLStatement = uploadList.attachment_file_name;
      }
      if (uploadList.entity_type_enum == 23) {
        uploadFileNameIncomeTaxReturnsLatest = uploadList.attachment_file_name;
      }
      if (uploadList.entity_type_enum == 24) {
        uploadFileNameIncomeTaxReturnsPreviousYear = uploadList.attachment_file_name;
      }
    }

    if (
      uploadList.entity_type_enum == 1 ||
      uploadList.entity_type_enum == 2 ||
      uploadList.entity_type_enum == 3 ||
      uploadList.entity_type_enum == 16 ||
      uploadList.entity_type_enum == 17 ||
      uploadList.entity_type_enum == 18
    ) {
      frontBackEnumValue == 1
        ? (attachmentIdFront = uploadList.attachment_id)
        : (attachmentIdBack = uploadList.attachment_id);
    } else {
      if (uploadList.entity_type_enum == 6) {
        attachmentIdBusinessReg = uploadList.attachment_id;
      }
      if (uploadList.entity_type_enum == 7) {
        attachmentIdCompany = uploadList.attachment_id;
      }
      if (uploadList.entity_type_enum == 8) {
        attachmentIdPropreitor = uploadList.attachment_id;
      }
      if (uploadList.entity_type_enum == 9) {
        attachmentIdNameForm12 = uploadList.attachment_id;
      }
      if (uploadList.entity_type_enum == 10) {
        attachmentIdNameForm80 = uploadList.attachment_id;
      }
      if (uploadList.entity_type_enum == 11) {
        attachmentIdAuthority = uploadList.attachment_id;
      }
      if (uploadList.entity_type_enum == 15) {
        attachmentIdCancelledCheque = uploadList.attachment_id;
      }

      ///////
      if (uploadList.entity_type_enum == 21) {
        attachmentIdBalanceSheet = uploadList.attachment_id;
      }
      if (uploadList.entity_type_enum == 22) {
        attachmentIdPLStatement = uploadList.attachment_id;
      }
      if (uploadList.entity_type_enum == 23) {
        attachmentIdIncomeTaxReturnsLatest = uploadList.attachment_id;
      }
      if (uploadList.entity_type_enum == 24) {
        attachmentIdIncomeTaxReturnsPreviousYear = uploadList.attachment_id;
      }
    }

    if (
      uploadList.entity_type_enum == 1 ||
      uploadList.entity_type_enum == 2 ||
      uploadList.entity_type_enum == 3 ||
      uploadList.entity_type_enum == 16 ||
      uploadList.entity_type_enum == 17 ||
      uploadList.entity_type_enum == 18
    ) {
      frontBackEnumValue == 1
        ? (attachmentPathFront = uploadList.attachment_path)
        : (attachmentPathBack = uploadList.attachment_path);
    } else {
      if (uploadList.entity_type_enum == 6) {
        attachmentPathBusinessReg = uploadList.attachment_path;
      }
      if (uploadList.entity_type_enum == 7) {
        attachmentPathCompany = uploadList.attachment_path;
      }
      if (uploadList.entity_type_enum == 8) {
        attachmentPathPropreitor = uploadList.attachment_path;
      }
      if (uploadList.entity_type_enum == 9) {
        attachmentPathNameForm12 = uploadList.attachment_path;
      }
      if (uploadList.entity_type_enum == 10) {
        attachmentPathNameForm80 = uploadList.attachment_path;
      }
      if (uploadList.entity_type_enum == 11) {
        attachmentPathAuthority = uploadList.attachment_path;
      }
      if (uploadList.entity_type_enum == 15) {
        attachmentPathCancelledCheque = uploadList.attachment_path;
      }
      //////
      if (uploadList.entity_type_enum == 21) {
        attachmentPathBalanceSheet = uploadList.attachment_path;
      }
      if (uploadList.entity_type_enum == 22) {
        attachmentPathPLStatement = uploadList.attachment_path;
      }
      if (uploadList.entity_type_enum == 23) {
        attachmentPathIncomeTaxReturnsLatest = uploadList.attachment_path;
      }
      if (uploadList.entity_type_enum == 24) {
        attachmentPathIncomeTaxReturnsPreviousYear = uploadList.attachment_path;
      }
    }
  }
  //=================================================================================
  return (
    <>
      <div className="notes-block d-inline-flex">
        <p className="greenbg">Provide all these details if you are interested in applying for Finance</p>
      </div>
      <div className="">
        <Formik
          initialValues={getInitialValues(financeDetails, entity_id, company_affiliate_enum, companyData)}
          onSubmit={handleCheck}>
          {(formikBag) => {
            const { values } = formikBag;
            // values.annual_turnover = +utils.formatPrice(56777);
            // console.log('finance values', typeof values.annual_turnover);
            return (
              <React.Fragment>
                <Form className="formik-form">
                  <div className="form-wrapper full-width">
                    <Card>
                      <CardBody className="main-cardbody">
                        <Collapse title="Business Details" className="with-shadow">
                          <Card>
                            <CardBody>
                              <div className="row form__form-group">
                                <div className="col-md-6 col-lg-5 col-xl-4">
                                  <span className="form-group-label">Year of Incorporation</span>
                                  <span class="required">*</span>
                                  <div className="form-group-field">
                                    <Field
                                      name="year_of_incorporation"
                                      component={FormikMaterialTextField}
                                      disabled={isAdmin || kycStatusKey}
                                      type="number"
                                      placeholder="YYYY"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6 col-lg-5 col-xl-4">
                                  <span className="form-group-label">Nature of Business</span>
                                  {company_affiliate_enum == 1 && <span class="required">*</span>}
                                  <div className="form-group-field">
                                    <Field
                                      name="nature_of_business_enum"
                                      component={ReferenceDataSelect}
                                      entity="NatureOfBusinessEnum"
                                      disabled={true}
                                      cb={(newVal) => {
                                        const display_member = _.get(newVal, 'display_member') || '';
                                        const value_member = _.get(newVal, 'value_member') || 0;
                                        formikBag.setFieldValue('nature_of_businessenum_code', display_member);
                                        formikBag.setFieldValue('nature_of_business_enum', value_member);
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row form__form-group">
                                <div className="col-md-6 col-lg-5 col-xl-4">
                                  <span className="form-group-label">Industry</span>
                                  <span class="required">*</span>
                                  <div className="form-group-field">
                                    <Field
                                      name="industry_type_enum"
                                      component={ReferenceDataSelect}
                                      entity="IndustryTypeEnum"
                                      disabled={isAdmin || kycStatusKey}
                                      cb={(newVal) => {
                                        const display_member = _.get(newVal, 'display_member') || '';
                                        const value_member = _.get(newVal, 'value_member') || 0;
                                        formikBag.setFieldValue('industry_type_enum_code', display_member);
                                        formikBag.setFieldValue('industry_type_enum', value_member);
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6 col-lg-5 col-xl-4">
                                  <span className="form-group-label">MSME Classification</span>
                                  <span class="required">*</span>
                                  <div className="form-group-field">
                                    <Field
                                      name="business_size_enum"
                                      component={ReferenceDataSelect}
                                      entity="BusinessSizeEnum"
                                      disabled={isAdmin || kycStatusKey}
                                      cb={(newVal) => {
                                        const display_member = _.get(newVal, 'display_member') || '';
                                        const value_member = _.get(newVal, 'value_member') || 0;
                                        formikBag.setFieldValue('business_size_enum_code', display_member);
                                        formikBag.setFieldValue('business_size_enum', value_member);
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row form__form-group">
                                <div className="col-md-6 col-lg-5 col-xl-4">
                                  <span className="form-group-label">People Employed</span>
                                  <span class="required">*</span>
                                  <div className="form-group-field">
                                    <Field
                                      name="people_employed_enum"
                                      component={ReferenceDataSelect}
                                      entity="PeopleEmployedEnum"
                                      disabled={isAdmin || kycStatusKey}
                                      cb={(newVal) => {
                                        const display_member = _.get(newVal, 'display_member') || '';
                                        const value_member = _.get(newVal, 'value_member') || 0;
                                        formikBag.setFieldValue('people_employed_enum_code', display_member);
                                        formikBag.setFieldValue('people_employed_enum', value_member);
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Collapse>

                        <Collapse title="Annual Turnover/ Sales" className="with-shadow">
                          <Card>
                            <CardBody>
                              <div className="row form__form-group">
                                <div className="col-md-6 col-lg-5 col-xl-4">
                                  <span className="form-group-label">Financial Year</span>
                                  <span class="required">*</span>
                                  <div className="form-group-field">
                                    <Field
                                      name="financial_year"
                                      component={FinancialYearSelect}
                                      placeholder="Select Financial Year"
                                      disabled={isAdmin || kycStatusKey}
                                      initialDisplayText={financeDetails.financial_year || ''}
                                      cb={(newVal) => {
                                        const value = _.get(newVal, 'value') || 0;
                                        formikBag.setFieldValue('financial_year', value);
                                      }}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-6 col-lg-5 col-xl-4">
                                  <span className="form-group-label">Annual Turnover/ Sales</span>
                                  <span class="required">*</span>
                                  <div className="form-group-field with-icon annual-turnover">
                                    <div className="form-group-icon">
                                      <RupeeIcon />
                                    </div>
                                    <Field
                                      name="annual_turnover"
                                      component={FormikMaterialTextFieldNumber}
                                      type="number"
                                      disabled={isAdmin || kycStatusKey}
                                    />
                                  </div>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Collapse>

                        <Collapse title="Installed Capacity" className="with-shadow" showStar={true}>
                          <Card>
                            <CardBody>
                              <InstalledCapacity
                                entity_id={entity_id}
                                company_affiliate_enum={company_affiliate_enum}
                                isAdmin={isAdmin}
                                kycStatusKey={kycStatusKey}
                                id={id}
                              />
                            </CardBody>
                          </Card>
                        </Collapse>

                        {type_of_individual_enum === 4 && true && (
                          <Collapse title="Upload Finance Documents" className="with-shadow">
                            <Card>
                              <CardBody>
                                <div className="row form__form-group">
                                  <div className="col-md-6 col-lg-5 col-xl-4">
                                    <span className="form-group-label">Financial Year</span>
                                    <span class="required">*</span>
                                    <div className="form-group-field">
                                      <Field
                                        name="financial_year"
                                        component={FormikMaterialTextField}
                                        disabled={true}
                                        type="number"
                                        placeholder="YYYY"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="row form__form-group">
                                  <Row className="col-md-12">
                                    <span className="form-group-label col-md-3">
                                      Balance Sheet <span class="required">*</span>
                                    </span>
                                    <div className="form-group-field col-md-9">
                                      <Field
                                        name="authorityLetter"
                                        entity_id={entity_id}
                                        entity_type_enum="21"
                                        front_back_enum="1"
                                        component={UploadDocument}
                                        fileName={uploadFileNameBalanceSheet}
                                        attachmentId={attachmentIdBalanceSheet}
                                        attachmentPath={attachmentPathBalanceSheet}
                                        disabled={isAdmin}
                                        company_affiliate_enum={company_affiliate_enum}
                                      />
                                    </div>
                                  </Row>
                                </div>
                                <div className="row form__form-group">
                                  <Row className="col-md-12">
                                    <span className="form-group-label col-md-3">
                                      P and L Statement<span class="required">*</span>
                                    </span>
                                    <div className="form-group-field col-md-9">
                                      <Field
                                        name="authorityLetter"
                                        entity_id={entity_id}
                                        entity_type_enum="22"
                                        front_back_enum="1"
                                        component={UploadDocument}
                                        fileName={uploadFileNamePLStatement}
                                        attachmentId={attachmentIdPLStatement}
                                        attachmentPath={attachmentPathPLStatement}
                                        disabled={isAdmin}
                                        company_affiliate_enum={company_affiliate_enum}
                                      />
                                    </div>
                                  </Row>
                                </div>
                                <div className="row form__form-group">
                                  <Row className="col-md-12">
                                    <span className="form-group-label col-md-3">
                                      Income Tax Returns (Latest)<span class="required">*</span>
                                    </span>
                                    <div className="form-group-field col-md-9">
                                      <Field
                                        name="authorityLetter"
                                        entity_id={entity_id}
                                        entity_type_enum="23"
                                        front_back_enum="1"
                                        component={UploadDocument}
                                        fileName={uploadFileNameIncomeTaxReturnsLatest}
                                        attachmentId={attachmentIdIncomeTaxReturnsLatest}
                                        attachmentPath={attachmentPathIncomeTaxReturnsLatest}
                                        disabled={isAdmin}
                                        company_affiliate_enum={company_affiliate_enum}
                                      />
                                    </div>
                                  </Row>
                                </div>
                                <div className="row form__form-group">
                                  <Row className="col-md-12">
                                    <span className="form-group-label col-md-3">
                                      Income Tax Returns (Previous Year)<span class="required">*</span>
                                    </span>
                                    <div className="form-group-field col-md-9">
                                      <Field
                                        name="authorityLetter"
                                        entity_id={entity_id}
                                        entity_type_enum="24"
                                        front_back_enum="1"
                                        component={UploadDocument}
                                        fileName={uploadFileNameIncomeTaxReturnsPreviousYear}
                                        attachmentId={attachmentIdIncomeTaxReturnsPreviousYear}
                                        attachmentPath={attachmentPathIncomeTaxReturnsPreviousYear}
                                        disabled={isAdmin}
                                        company_affiliate_enum={company_affiliate_enum}
                                      />
                                    </div>
                                  </Row>
                                </div>
                              </CardBody>
                            </Card>
                          </Collapse>
                        )}
                      </CardBody>
                    </Card>

                    <div className="btn-wrapper justify-content-space-between">
                      <div className="">
                        <NavLink to={getUrlWithEncryptedQueryParams(prevLink)} color="link">
                          Prev
                        </NavLink>
                      </div>
                      {!isAdmin && !kycStatusKey && (
                        <div>
                          <Button
                            color="primary"
                            type="button"
                            size="sm"
                            onClick={() => {
                              formikBag.handleSubmit(formikBag.values, formikBag);
                            }}
                            className="next bfc-button-next">
                            {props.isSubmitting && (
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"></span>
                            )}{' '}
                            Save
                          </Button>
                        </div>
                      )}
                      <div className="">
                        {isAdmin && (
                          <NavLink to={getUrlWithEncryptedQueryParams(nextLink)} color="link">
                            Next
                          </NavLink>
                        )}
                      </div>
                    </div>
                  </div>
                </Form>
              </React.Fragment>
            );
          }}
        </Formik>
      </div>
    </>
  );
};

export default FinanceForm;
